import { watch, onMounted } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';

/**
 * Composable that applies per-account branding to favicon and document.title.
 * Should be called once in the main dashboard layout (e.g. Sidebar.vue).
 */
export function useBrandedAccount() {
  const { currentAccount } = useAccount();

  const applyBranding = () => {
    const account = currentAccount.value;
    if (!account) return;

    const isBrandedEnabled =
      window.chatwootConfig?.brandedLoginEnabled === 'true';
    if (!isBrandedEnabled) return;

    // Apply favicon from branded_icon_url
    if (account.branded_icon_url) {
      const faviconLinks = document.querySelectorAll(
        'link.favicon, link[rel="icon"]'
      );
      faviconLinks.forEach(link => {
        link.href = account.branded_icon_url;
      });
    }

    // Apply page title from account name
    if (account.name) {
      document.title = account.name;
    }

    // Persist slug for logout redirect and update manifest link
    const slug = account.settings?.slug;
    if (slug) {
      sessionStorage.setItem('branded_account_slug', slug);
      // Update manifest link to branded version for PWA installation
      const manifestLink = document.querySelector('link[rel="manifest"]');
      if (manifestLink) {
        manifestLink.href = `/manifest/${slug}.json`;
      }
    }
  };

  onMounted(() => {
    applyBranding();
  });

  watch(currentAccount, () => {
    applyBranding();
  });

  return { applyBranding };
}
